export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/1f7d47ea90626bffe8094176fdfa1011.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="inline-block px-4 py-2 border border-white/30 rounded-full mb-8">
          <span className="text-white text-xs uppercase tracking-wider">iOS Development Experts</span>
        </div>
        
        <h1 className="text-6xl md:text-7xl font-bold mb-6">
          <span className="text-white block">Modern Applications</span>
          <span className="text-purple-300 block mt-2">for iOS Platform</span>
        </h1>
        
        <p className="text-white/90 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed mb-12">
          A team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
        </p>
      </div>
    </section>
  );
}